import React, { useState, useEffect } from 'react'
import { Button, Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { getIndigenousCommunities } from '../../../../../services/AsistenciaTecnica/get'
import DeleteIcon from '@mui/icons-material/Delete'
import { deleteIndigenousCommunities } from '../../../../../services/AsistenciaTecnica/delete'
import swal from 'sweetalert'
import EditIcon from '@mui/icons-material/Edit'
import { Modal272 } from '../../Modals/ModalSec2/Modal272'

export const Table272 = ({
  IdTechnicalAssistanceAnswer,
  IndigenousCommunitiesNumber,
  formik,
}) => {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [body, setBody] = useState({})
  const [disabledButton, setDisabledButton] = useState(false)

  const getIndigenousCommunitiesList = async () => {
    try {
      const response = await getIndigenousCommunities(
        IdTechnicalAssistanceAnswer,
      )
      if (response.Success) {
        setData(response.Data)

        if (response.Data.length === IndigenousCommunitiesNumber) {
          formik('validateTable272', true)
          setDisabledButton(true)
        } else {
          setDisabledButton(false)
          formik('validateTable272', false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await deleteIndigenousCommunities(id)

      if (response.Success) {
        swal({
          title: '¡Registro eliminado exitosamente!',
          icon: 'success',
        })
        getIndigenousCommunitiesList()
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      IdTechnicalAssistanceAnswer !== '' &&
      IdTechnicalAssistanceAnswer !== null &&
      IdTechnicalAssistanceAnswer !== undefined
    )
      getIndigenousCommunitiesList()
  }, [IdTechnicalAssistanceAnswer, IndigenousCommunitiesNumber])

  const columns = [
    {
      title: 'Nombre comunidad indígena representada',
      field: 'Description',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={data}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            actions={[
              {
                icon: () => (
                  <Button
                    variant="contained"
                    color="success"
                    style={
                      disabledButton
                        ? {}
                        : { backgroundColor: '#27C27D', color: '#FFFFFF' }
                    }
                    startIcon={<AddIcon style={{ color: 'white' }} />}
                    disabled={disabledButton}
                    onClick={() => {
                      setOpen(true)
                    }}
                  >
                    Agregar registro
                  </Button>
                ),
                tooltip: 'Agregar',
                position: 'toolbar',
              },
              {
                icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                tooltip: 'Editar',
                onClick: (event, rowData) => {
                  setOpen(true)
                  setBody(rowData)
                },
              },
              {
                icon: () => <DeleteIcon style={{ color: 'red' }} />,
                tooltip: 'Eliminar registro',
                onClick: (event, rowData) => {
                  swal({
                    title: '¿Está seguro de eliminar el registro?',
                    icon: 'warning',
                    buttons: ['No', 'Si'],
                    dangerMode: true,
                  }).then(function (isConfirm) {
                    if (isConfirm) {
                      handleDelete(rowData.IdIndigenousCommunity)
                    }
                  })
                },
              },
            ]}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
          />
        </Grid>
        <Modal272
          open={open}
          setOpen={setOpen}
          getIndigenousCommunitiesList={getIndigenousCommunitiesList}
          body={body}
          setBody={setBody}
          IdTechnicalAssistanceAnswer={IdTechnicalAssistanceAnswer}
        />
      </Grid>
    </>
  )
}
